
import React from 'react';
import { HashRouter, Routes, Route, useLocation, Link } from 'react-router-dom';
import Home from './pages/Home';
import Works from './pages/Works';
import About from './pages/About';
import Contact from './pages/Contact';

const Navigation = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  // The request specifically asked for NO navigation bar.
  // We provide discrete navigation links at corners to maintain the minimal, premium look.
  return (
    <nav className="fixed inset-0 pointer-events-none z-50 p-6 md:p-10 flex flex-col justify-between">
      <div className="flex justify-between items-start pointer-events-auto">
        <Link 
          to="/" 
          className={`text-sm font-semibold tracking-tighter transition-all hover:text-cyan-400 ${isHome ? 'opacity-0 invisible' : 'opacity-100'}`}
        >
          RADIANT.
        </Link>
        <Link 
          to="/works" 
          className={`text-sm uppercase tracking-widest transition-all hover:text-cyan-400 ${location.pathname === '/works' ? 'text-cyan-500 underline underline-offset-8' : ''}`}
        >
          Works
        </Link>
      </div>
      <div className="flex justify-between items-end pointer-events-auto">
        <Link 
          to="/about" 
          className={`text-sm uppercase tracking-widest transition-all hover:text-cyan-400 ${location.pathname === '/about' ? 'text-cyan-500 underline underline-offset-8' : ''}`}
        >
          About
        </Link>
        <Link 
          to="/contact" 
          className={`text-sm uppercase tracking-widest transition-all hover:text-cyan-400 ${location.pathname === '/contact' ? 'text-cyan-500 underline underline-offset-8' : ''}`}
        >
          Contact
        </Link>
      </div>
    </nav>
  );
};

const App: React.FC = () => {
  return (
    <HashRouter>
      <div className="min-h-screen bg-[#020617] text-slate-100 selection:bg-cyan-500/30">
        <Navigation />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/works" element={<Works />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
      </div>
    </HashRouter>
  );
};

export default App;
